import { createRef, useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { add, format } from "date-fns";
import { v4 as uuid } from 'uuid'
import html2canvas from "html2canvas";
import { TiMessages } from 'react-icons/ti'
import { IoSend } from "react-icons/io5";
import { MdOutlineAlternateEmail } from 'react-icons/md'
import { TabelaAcordoParcelas } from "../tabela";
import { Button } from "../../../../../../../../generics/button";
import { useBoleto } from "../../../../../../../../../context/BoletoContext";
import { useDividas } from "../../../../../../../../../context/DividasContext";
import { TemplateProps, useChatWhatsApp } from "../../../../../../../../../context/ChatWhatsAppContext";
import { useAuth } from "../../../../../../../../../context/AuthContext";
import { useFila } from "../../../../../../../../../context/FilaContext";
import { useModal } from "../../../../../../../../../hooks/ModalContext";
import { useNeg } from "../../../../../../../../../context/NegContext";
import { usePropostas } from "../../../../../../../../../context/PropostasContext";
import { useContrato } from "../../../../../../../../../context/ContratoContext";
import { useFilaTransbordo } from "../../../../../../../../../context/FilaTransbordoContext";


interface ResumoAcordoAccordionProps {
  formaPag: string;
  vencimento: string;
  app: string
}

interface CanalEnvio {
  canalrecebimento: string
  destinorecebimento: string
}

export const ResumoAcordoAccordion = ({ formaPag, vencimento, app }: ResumoAcordoAccordionProps) => {
  const { selectedProposta, canalEnvio, selectedContrato } = usePropostas()
  const { simulcaoCalculadora, contratoNeg, parcelasNeg } = useNeg()
  const { selectedCredor, devedor, devedorCadastro } = useDividas()
  const { enviarBoleto, boleto } = useBoleto()
  const ref = createRef<HTMLDivElement>();
  const { sendImage, enviarMessages } = useChatWhatsApp()
  const { devedorFilaSelected } = useFila()
  const { devedorFilaSelected: devedorFilaSelectedTransbordo } = useFilaTransbordo()
  const { setModal } = useModal()
  const { cookies } = useAuth()
  const queryClient = useQueryClient()
  const { dividaData } = useContrato()

  // const [canalEnvio, setCanalEnvio] = useState<CanalEnvio>({
  //   canalrecebimento: 'sms',
  //   destinorecebimento: '11992076161'
  // } as CanalEnvio)


  const [canal, setCanal] = useState<{ canal: string; destino: string }[]>([])


  useEffect(() => {
    if (formaPag !== 'Pgto em loja') {
      if (canalEnvio.canalrecebimento === 'email;sms') {
        const [canalEmail, canalSms] = canalEnvio.destinorecebimento.split(';')
        setCanal([
          {
            canal: 'email',
            destino: canalEmail
          },
          {
            canal: 'sms',
            destino: canalSms
          },
        ])
      } else {
        setCanal([{ canal: canalEnvio.canalrecebimento, destino: canalEnvio.destinorecebimento }])
      }
    }
  }, [canalEnvio])

  function formatDate(date: string) {
    if (date) {
      const [dia, mes, ano] = date?.split('/')
      const dataFormatada = `${mes}/${dia}/${ano}`
      const dataParaAdd = new Date(dataFormatada)
      const dataAdd = add(dataParaAdd, { days: 30 })
      return format(dataAdd, 'dd/MM/yyyy')
    }
  }

  function formatarTelefone(telefone: string) {
    if (telefone && telefone !== '') {
      telefone = telefone.replace(/\D/g, '');
      telefone = telefone.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
      return telefone;
    }
    return ''
  }
  function goToOpeningAccordion() {
    const element = document.getElementById("acordo");
    if (element) {
      document.getElementById("acordo")?.setAttribute("open", "true");
      element.scrollIntoView({ behavior: "smooth" });
    }
  }
  async function concluirAcordo() {
    if (formaPag !== 'Pgto em loja') {
      if (simulcaoCalculadora?.propostas.proposta.id && canalEnvio.destinorecebimento !== '' && canalEnvio.canalrecebimento !== '') {
        if (canalEnvio.canalrecebimento === 'email;sms') {
          const [email, sms] = canalEnvio.destinorecebimento.split(';')
          if (email === '' || sms === '') {
            setModal('Selecione uma proposta e canal de envio primeiro', 'Aviso', false, false, true);
            return
          }
        }
      }
    }
    const modo = contratoNeg?.permiteacordo ? '0' : parcelasNeg?.length === dividaData?.length ? '1' : '2'
    const idsParcelas: string[] = parcelasNeg.map((parcela) => parcela.id);
    const idBoleto: string = idsParcelas.join(";");

    const data = {
      url: selectedCredor.url_ws,
      contrato: contratoNeg ? contratoNeg.numcontrato : simulcaoCalculadora?.contrato,
      cpf_cnpj: devedorCadastro?.cpfcnpj || '',
      codcredor: contratoNeg ? contratoNeg.codcredor : simulcaoCalculadora?.codcredor,
      idproposta: modo === '2' ? idBoleto : simulcaoCalculadora?.propostas?.proposta?.id,
      modo: modo,
      canalrecebimento: canalEnvio.canalrecebimento,
      destinorecebimento: canalEnvio.destinorecebimento,
      vencimento: simulcaoCalculadora?.vencimento,
      formapagamento: formaPag === 'Boleto' ? '1' : formaPag === 'PIX' ? '4' : '5',
      app
    }
    // console.log(String(cookies?.user?.id_operador))

    await enviarBoleto(data, String(cookies?.user?.id_operador))
  }

  async function handleAcordo() {
    await concluirAcordo();
    goToOpeningAccordion();
  }

  async function enviarResumo() {
    const referece = document.getElementById('print')!
    const canvas = await html2canvas(ref.current || referece)
    const image = canvas.toDataURL("image/png")

    const [imageType, data] = String(image)?.split(';')
    const [, file] = data?.split(',')
    const imageTypeFormated = imageType?.replace('data:', '')
    const fileName = `${uuid()}.png`
    const token = cookies?.whatsapp?.token || ''
    // ae858b53_f766_4e30_a45e_492ae6414511
    // resumo_selo
    // 3c5ccab3_0eb9_44d0_bc36_9da9d2039ed1
    // selo_resumo
    const templateToSend: TemplateProps = {
      namespace: 'cff93b07_25ff_4af5_937a_5d720edd0d44',
      name: 'selo_resumo',
      language: {
        "policy": "deterministic",
        "code": "pt_BR"
      },
      components: [
        {
          type: "body",
          parameters: [
            {
              type: "text",
              text: `Sr(a) ${devedorCadastro?.nomclien?.split(' ')[0]} segue a proposta para efetivar seu acordo ${selectedCredor.nome} , você confirma esta opção?`
            },

          ]
        }
      ]
    }

    const chat = devedorFilaSelectedTransbordo?._id || devedorFilaSelected.id_chat || ''

    await sendImage({ file, contentType: imageTypeFormated, fileName, token, chat, templateToSend })
    await queryClient.refetchQueries({ queryKey: ['firstMessages'] })
    await enviarMessages({ type: 'text', text: 'Enviado template de pergunta sobre o resumo do acordo', onlySave: true, token, chat })


    // copyImageToClipboard(image)
  }

  return (
    <details
      id="resumo"
      className={`mb-3 w-full border border-gray-300 bg-white ${((!canalEnvio.canalrecebimento && !simulcaoCalculadora?.propostas?.proposta?.id) || parcelasNeg?.length === 0) && 'pointer-events-none'}`}
    >
      <summary className="flex w-full cursor-pointer justify-between bg-white px-4 py-3 text-xl font-medium text-gray-800 after:content-['+']">
        Resumo do Acordo
      </summary>


      {
        ((canalEnvio.canalrecebimento && simulcaoCalculadora?.propostas?.proposta?.id) ||
          (!canalEnvio.canalrecebimento && simulcaoCalculadora?.propostas?.proposta?.id && formaPag === 'Pgto em loja') || (!canalEnvio.canalrecebimento && contratoNeg && formaPag === 'Pgto em loja')) && (
          <div className="px-4 py-2">

            <div ref={ref} id="print" className="px-4 py-2">
              <div className="flex w-full gap-4 ">
                {
                  simulcaoCalculadora?.propostas?.proposta?.id && contratoNeg && contratoNeg.numcontrato && (
                    <div className="flex h-full w-1/2 flex-col items-center">
                      <p className="font-medium text-primary ">
                        Operações envolvidas no acordo
                      </p>
                      <p className="font-medium text-gray-700">{selectedCredor.nome}</p>
                      <div>
                        <TabelaAcordoParcelas prestacoes={parcelasNeg} />
                      </div>
                    </div>
                  )
                }

                <div className={`flex  ${!contratoNeg && simulcaoCalculadora?.propostas?.proposta?.id ? 'w-1/2' : 'w-full'}  flex-col items-center justify-center rounded bg-gray-100 p-4 text-xs`}>
                  <p className="font-medium text-primary ">Detalhes da negociação</p>
                  <div className=" text-right">
                    <div className="my-4 grid grid-cols-2 gap-4  text-gray-800">
                      <strong>Tipo de negociação: </strong>
                      <p>{simulcaoCalculadora?.propostas?.proposta?.tipo === 'AV' ? 'Á vista' : 'Á prazo'}</p>

                      <strong>Forma de pagamento: </strong>
                      <p>{formaPag}</p>

                      {
                        simulcaoCalculadora?.propostas?.proposta?.tipo === 'AP' && (
                          <>
                            <strong>Valor da entrada: </strong>
                            <p>R$ {simulcaoCalculadora?.propostas?.proposta?.valorentrada}</p>
                          </>
                        )
                      }

                      {
                        simulcaoCalculadora?.propostas?.proposta?.tipo === 'AP' && (
                          <>
                            <strong>Demais parcelas: </strong>
                            <p>{simulcaoCalculadora?.propostas?.proposta?.qtdeparcela}x R$ {simulcaoCalculadora?.propostas?.proposta?.valorparcela}</p>
                          </>
                        )
                      }

                      <strong>Vencimento {simulcaoCalculadora?.propostas?.proposta?.tipo === 'AP' && 'da entrada'} : </strong>
                      <p>{simulcaoCalculadora?.vencimento}</p>

                      <strong>Valor atualizado: </strong>
                      <p>R$ {simulcaoCalculadora?.propostas?.proposta?.valorcorrigido}</p>

                      <strong>Desconto: </strong>
                      <p>R$ {simulcaoCalculadora?.propostas?.proposta?.valordesconto}</p>

                      <strong>Total a pagar: </strong>
                      <p>R$ {simulcaoCalculadora?.propostas?.proposta?.valortotal}</p>
                    </div>
                  </div>

                  {
                    formaPag !== 'Pgto em loja' && (
                      <div className="my-2 flex flex-col text-sm gap-2 border-2 p-4 border-primary rounded-md">
                        <p>Enviaremos seu boleto para os canais cadastrados:</p>
                        {
                          canal.length > 0 && canal.map(envio => (
                            <div className="" key={envio.canal}>
                              <div className="flex items-center  font-bold text-primary ">
                                {
                                  envio.canal === 'email' ? (<>
                                    <MdOutlineAlternateEmail size={18} className="fill-primary" />
                                    <p className="mx-2">E-mail</p>
                                  </>) : (<>
                                    <TiMessages size={18} className="fill-primary" />
                                    <p className="mx-2">SMS</p>
                                  </>)
                                }

                              </div>
                              <p>{envio.canal === 'sms' ? formatarTelefone(envio.destino) : envio.destino}</p>
                            </div>
                          ))
                        }

                      </div>
                    )
                  }
                </div>

              </div>


            </div>


            <div>
              <div className="my-4 flex items-center justify-evenly ">
                {
                  (devedorFilaSelected?.id_chat || devedorFilaSelectedTransbordo?._id) && simulcaoCalculadora?.propostas?.proposta?.id && (
                    <div className="flex w-full items-center justify-center">
                      <button className="flex items-center justify-center gap-4 h-8 w-[90%]  bg-green-500 rounded-md  text-white " onClick={enviarResumo}>
                        <IoSend size={20} className="fill-white" />
                        {/* <img src={copyCodeGreenIcon} alt="" /> */}
                        Enviar resumo
                      </button>
                    </div>
                  )
                }
                {
                  boleto && boleto?.url ? (<></>) : (
                    <Button
                      name="Concluir acordo"
                      width="w-[100%]"
                      onClick={() => {
                        handleAcordo()
                      }}
                    />
                  )
                }
              </div>
            </div>
          </div>
        )
      }
    </details>
  );
};
